import { Alert, AlertIcon, AlertProps, AlertTitle, forwardRef } from "@chakra-ui/react";

export interface AppAlertProps extends AlertProps {
  title: string;
  description?: JSX.Element;
}

export const AppAlert = forwardRef((props: AppAlertProps, ref) => {
  const { title, description } = props;
  return <Alert status={props.status || 'error'}>
    <AlertIcon />
    <AlertTitle>{title}</AlertTitle>
    {description}
  </Alert>;
});
